import { RequestState } from '../../api/constants/RequestState';
import {
  useAuthData,
  useAuthTokensRefreshData,
} from '../../contexts/AuthContext';

/**
 * True while a stored session's access token is invalid (expired) and a refresh
 * has not yet failed.
 *
 * This distinguishes "a session exists but its token is being refreshed" (show
 * loading, do not redirect) from "no session / the refresh failed" (redirect to
 * login). On refresh failure the tokens are cleared and the refresh state goes
 * to Error, so this returns false and the caller falls through to the redirect.
 */
export const useIsRefreshingSession = (): boolean => {
  const tokens = useAuthData();
  const { isTokenValid, tokenRefreshState } = useAuthTokensRefreshData();

  const hasStoredTokens = !!tokens?.expiresAt;

  return (
    hasStoredTokens && !isTokenValid && tokenRefreshState !== RequestState.Error
  );
};
